import { createAsyncThunk } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { ApiCall, GetApiCall } from '../../helper/axios';

export const getRuleAsync = createAsyncThunk('fetch/getRule', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const { limit, status, search, page, sort } = param.payload;
    let url = `/rules?shop=${config_variable.shop_name}`;
    if (status) {
        url += `&status=${status}`;
    }
    if (search) {
        url += `&search=${search}`;
    }
    if (limit) {
        url += `&limit=${limit}`;
    }
    if (page) {
        url += `&page=${page}`;
    }
    if (sort) {
        url += `&sort=${sort}`;
    }
    const res = await GetApiCall('GET', url, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const createRuleAsync = createAsyncThunk('fetch/createRule', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('POST', `/rules?shop=${config_variable.shop_name}`, param.payload, { authentication: store_data?.token })
    await new Promise((res) =>
        setTimeout(() => {
            res();
        }, [500])
    );
    if (res.data.success && res.data?.statusCode === 200) {
        param.callback(res.data.message);
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const getRuleByIdAsync = createAsyncThunk('fetch/getRuleById', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await GetApiCall('GET', `/rules/${param.payload.id}?shop=${config_variable.shop_name}`, { authentication: store_data?.token })
    await new Promise((res) =>
        setTimeout(() => {
            res();
        }, [500])
    );
    if (res.data.success && res.data?.statusCode === 200) {
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const deleteRuleAsync = createAsyncThunk('fetch/deleteRule', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('DELETE', `/rules?shop=${config_variable.shop_name}`, param.payload, { authentication: store_data?.token })
    await new Promise((res) =>
        setTimeout(() => {
            res();
        }, [500])
    );
    if (res.data.success && res.data?.statusCode === 200) {
        param.callback(res.data.message);
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const manualProcessRulesAsync = createAsyncThunk('fetch/manualProcessRules', async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await GetApiCall('GET', `/manual/process-rules?shop=${config_variable.shop_name}`, { authentication: store_data?.token })
    await new Promise((res) =>
        setTimeout(() => {
            res();
        }, [500])
    );
    if (res.data.success && res.status === 200) {
        _.callback(res.data.success, res?.data?.message)
        return res?.data?.message;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});